module.exports = __webpack_public_path__ + "img/Hongkong-2-hover.c79d867c.jpg";